export enum TipoDePagamentoEnum {
  Boleto = 'boleto',
  Cartao = 'cartao',
  CartaoCredito = 'cartao-credito' ,
  CartaoDebito = 'cartao-debito',
  Transferencia = 'transferencia',
  Dinheiro = 'dinheiro',
  Cashback = 'cashback'
}
